import { useEffect } from "react";

const BASE = "GMScan — Robinhood Chain Explorer";

export const usePageTitle = (title, description) => {
  useEffect(() => {
    document.title = title ? `${title} | ${BASE}` : BASE;
    if (description) {
      const meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", description);
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", window.location.origin + window.location.pathname);
    return () => { document.title = BASE; };
  }, [title, description]);
};
